export const zhCN = {
  // 通用按钮和文本
  "Send": "发送",
  "Clear": "清除",
  "Stop": "停止",
  "New Session": "新建会话",
  "Sessions": "会话",
  "Tools": "工具",
  "Settings": "设置",
  "Models": "模型",
  "Agents": "代理",
  "Memory": "记忆",
  "Files": "文件",
  "Logs": "日志",
  "Debug": "调试",
  "Channels": "频道",
  "Cron": "定时任务",
  "Skills": "技能",
  "Overview": "概览",
  
  // 聊天界面
  "Type a message...": "输入消息...",
  "Thinking...": "思考中...",
  "Loading...": "加载中...",
  "No messages yet": "暂无消息",
  "System": "系统",
  
  // 设置相关
  "Gateway URL": "网关URL",
  "Token": "令牌",
  "Theme": "主题",
  "Language": "语言",
  "Save": "保存",
  "Cancel": "取消",
  "Apply": "应用",
  "Reload": "重载",
  
  // 状态文本
  "Connected": "已连接",
  "Disconnected": "已断开",
  "Connecting...": "连接中...",
  "Error": "错误",
  "Success": "成功",
  
  // 文件操作
  "Upload": "上传",
  "Download": "下载",
  "Delete": "删除",
  "Edit": "编辑",
  "Copy": "复制",
  "Copied!": "已复制！",
  
  // 其他
  "Close": "关闭",
  "Preview": "预览",
  "Code": "代码",
  "Required": "必填",
  "Optional": "可选",
  "Confirm": "确认",
  "Yes": "是",
  "No": "否"
};